import URLUtils from "../data-amazon_api_gateway/URLUtils";
import Campaign from "../domain/entities/Campaign";
import { History, PostComment } from "../domain/entities/Chat";
import Document, { DocumentStatus } from "../domain/entities/Document";
import DocumentTemplate from "../domain/entities/DocumentTemplate";
import Enrollment from "../domain/entities/Enrollment";
import Organization, {
  OrganizationStatus,
} from "../domain/entities/Organization";
import Package from "../domain/entities/Package";
import Permission from "../domain/entities/Permission";
import PermissionType from "../domain/entities/PermissionType";
import Role, { RoleLevel } from "../domain/entities/Role";
import Signatory from "../domain/entities/Signatory";
import SignatoryGroup, {
  SignatoryFormType,
} from "../domain/entities/SignatoryGroup";
import Student from "../domain/entities/Student";
import User from "../domain/entities/User";
import { pdf } from "./base64Data";

export const baseURL: any = URLUtils.getBaseURL() || "";
export const cleanDomain: string = baseURL.replace(
  /^(https?:\/\/)?(www\.)?/,
  ""
);

export const signatories: Signatory[] = [
  {
    id: "sig01",
    username: "UsrSignatory01",
    firstName: "Steph",
    lastName: "Client",
    email: "signatory01@client.com",
    dateOfBirth: new Date(),
  },
  {
    id: "sig02",
    username: "UsrSignatory02",
    firstName: "John",
    lastName: "Client",
    dateOfBirth: new Date(),
    email: "signatory02@client.com",
  },
  {
    id: "sig03",
    username: "UsrSignatory03",
    firstName: "Juan",
    lastName: "Client",
    email: "signatory3@client.com",
    dateOfBirth: new Date(),
  },
  {
    id: "sig04",
    username: "UsrSignatory04",
    firstName: "Mike",
    lastName: "Client",
    email: "signatory4@client.com",
    dateOfBirth: new Date(),
  },
];

export const demoRootOrg: Organization = {
  id: "paisley-id-001",
  name: "Paisley Inc",
  description: "Paisley Inc Desc",
  status: OrganizationStatus.ACTIVE,
  url: baseURL,
  childOrganizations: [],
  parentOrganization: undefined,
};
export const demoDist01: Organization = {
  id: "12f98a21-2d39-41b8-9cae-8uigf7asf8af",
  description: "Test District Organization 01",
  name: "Test District Org 01",
  status: OrganizationStatus.ACTIVE,
  url: baseURL,
  childOrganizations: [],
  parentOrganization: undefined,
};
export const demoDist02: Organization = {
  id: "31170526-0d63-4368-9548-a3e6678b731a",
  description: "Test District Organization 02",
  name: "Test District Org 02",
  status: OrganizationStatus.ACTIVE,
  url: baseURL,
  childOrganizations: [],
  parentOrganization: undefined,
};
export const demoChild01: Organization = {
  id: "31f98a21-2d39-41b8-9cae-ydbf9we78sv8",
  description: "Test Children Organization 01",
  name: "Test Children Org 01",
  status: OrganizationStatus.ACTIVE,
  url: baseURL,
  childOrganizations: [],
  parentOrganization: undefined,
};
export const demoChild02: Organization = {
  id: "41f98a21-2d39-41b8-9cae-xc8asdf7asd7",
  description: "Test Children Organization 02",
  name: "Test Children Org 02",
  status: OrganizationStatus.ACTIVE,
  url: baseURL,
  childOrganizations: [],
  parentOrganization: undefined,
};
export const demoChild03: Organization = {
  id: "51f98a21-2d39-41b8-9cae-visdc7as5da9",
  description: "Test Children Organization 03",
  name: "Test Children Org 03",
  status: OrganizationStatus.ACTIVE,
  url: baseURL,
  childOrganizations: [],
  parentOrganization: undefined,
};
export const demoChild04: Organization = {
  id: "61f98a21-2d39-41b8-9cae-ad87va6da6sd",
  description: "Test Children Organization 04",
  name: "Test Children Org 04",
  status: OrganizationStatus.ACTIVE,
  url: baseURL,
  childOrganizations: [],
  parentOrganization: undefined,
};

function assignOrganizationRelationships() {
  demoRootOrg.childOrganizations = [demoDist01, demoDist02];
  //demoDist01.parentOrganization = demoRootOrg;
  demoDist01.childOrganizations = [demoChild01, demoChild02];
  //demoDist02.parentOrganization = demoRootOrg;
  demoDist02.childOrganizations = [demoChild03, demoChild04];
  //demoChild01.parentOrganization = demoDist01;
  //demoChild02.parentOrganization = demoDist01;
  //demoChild03.parentOrganization = demoDist02;
  //demoChild04.parentOrganization = demoDist02;
}
assignOrganizationRelationships();

export const organizations: Organization[] = [demoDist01, demoDist02];

export const roles: Role[] = [
  {
    id: "r1",
    description: "Paisley Administrator",
    level: RoleLevel.PaisleyAdministrator,
    name: "PaisleyAdministrator",
  },
  {
    id: "r2",
    description: "Administrator",
    level: RoleLevel.Administrator,
    name: "Administrator",
  },
  {
    id: "r3",
    description: "Signature Requestor",
    level: RoleLevel.SignatureRequestor,
    name: "Requestor",
  },
  {
    id: "r4",
    description: "Signatory",
    level: RoleLevel.Signatory,
    name: "Signatory",
  },
  { id: "r5", description: "Guest", level: RoleLevel.Guest, name: "Guest" },
];

export const users: User[] = [
  {
    id: "u1",
    dateOfBirth: new Date(),
    email: "administrator@paisley.com",
    firstName: "Admin",
    lastName: "User",
    organization: demoRootOrg,
    role: roles[0],
    username: "administrator@paisley.com",
    lastLogin: new Date(),
  },
  {
    id: "u2",
    dateOfBirth: new Date(),
    email: "administrator@client.com",
    firstName: "Admin",
    lastName: "User",
    organization: demoDist01,
    role: roles[1],
    username: "administrator@client.com",
    lastLogin: new Date(),
  },
  {
    id: "u3",
    dateOfBirth: new Date(),
    email: "administrator@client.com",
    firstName: "Admin",
    lastName: "User",
    organization: demoDist02,
    role: roles[1],
    username: "administrator@client.com",
    lastLogin: new Date(),
  },
  {
    id: "u5",
    dateOfBirth: new Date(),
    email: "requestor@client.com",
    firstName: "Requestor",
    lastName: "User",
    organization: organizations[1],
    role: roles[2],
    username: "requestor@client.com",
    lastLogin: new Date(),
  },
  {
    id: "u6",
    dateOfBirth: new Date(),
    email: "signatory@client.com",
    firstName: "Signatory",
    lastName: "User",
    organization: organizations[1],
    role: roles[3],
    username: "signatory@client.com",
    lastLogin: new Date(),
  },
  {
    id: "u7",
    dateOfBirth: new Date(),
    email: "",
    firstName: "Signatory",
    lastName: "User",
    organization: organizations[0],
    role: roles[4],
    username: "",
    lastLogin: new Date(),
  },
];

export const documentTemplates: DocumentTemplate[] = [
  {
    id: "dt1",
    templateOwner: users[1],
    description: "Field trip permission slip - Zoo",
    name: "Field trip permission slip - Zoo",
    file: pdf,
    signaturePositionFile: pdf,
    creationTime: new Date(),
    organization: organizations[0],
    shared: true,
    sharedWithOrgChilds: false,
  },
  {
    id: "dt2",
    templateOwner: users[1],
    description: "Field trip permission slip - Factory",
    name: "Field trip permission slip - Factory",
    file: pdf,
    signaturePositionFile: pdf,
    modifyingUser: users[0],
    creationTime: new Date(),
    organization: organizations[0],
    shared: false,
    sharedWithOrgChilds: false,
  },
  {
    id: "dt3",
    templateOwner: users[2],
    description: "Information Bulletin",
    name: "Information Bulletin",
    file: pdf,
    signaturePositionFile: pdf,
    modifyingUser: undefined,
    creationTime: new Date(),
    organization: organizations[0],
    shared: false,
    sharedWithOrgChilds: false,
  },
  {
    id: "dt4",
    templateOwner: users[2],
    description: "Memo",
    name: "Memo",
    file: pdf,
    signaturePositionFile: pdf,
    modifyingUser: undefined,
    creationTime: new Date(),
    organization: organizations[1],
    shared: true,
    sharedWithOrgChilds: false,
  },
  {
    id: "dt5",
    templateOwner: users[2],
    description: "Doc template n5",
    name: "This is the doc template n5",
    file: pdf,
    signaturePositionFile: pdf,
    modifyingUser: undefined,
    creationTime: new Date(),
    organization: organizations[1],
    shared: false,
    sharedWithOrgChilds: false,
  },
];

export const packages: Package[] = [
  {
    id: "p1",
    organization: organizations[1],
    name: "3rd Grade Permission Slip",
    description: "Field trip to Zoo",
    documentTemplates: [documentTemplates[0]],
    shared: false,
  },
  {
    id: "p2",
    organization: organizations[1],
    description: "4rd Grade Permission Slip",
    name: "Field trip to Kidzania",
    documentTemplates: [documentTemplates[1]],
    modifyingUser: users[0],
    shared: true,
  },
  {
    id: "p3",
    organization: organizations[1],
    description: "5rd Grade Permission Slip",
    name: "Field trip to Factory",
    documentTemplates: [documentTemplates[1], documentTemplates[2]],
    shared: false,
  },
];

export const signatoryGroups: SignatoryGroup[] = [
  {
    id: "sg01",
    organization: organizations[0],
    name: "4th Grade",
    description: "Mrs. Jones' 4th Grade Homeroom",
    signatories: [signatories[0], signatories[1]],
    type: SignatoryFormType.MANUAL,
  },
  {
    id: "sg02",
    organization: organizations[0],
    name: "5th Grade",
    description: "Mrs. Taylor's 5th Grade Homeroom",
    signatories: [signatories[1], signatories[2]],
    type: SignatoryFormType.MANUAL,
  },
  {
    id: "sg03",
    organization: organizations[0],
    name: "4th Grade Volunteers",
    description: "Parent Chaparones for Fieldtrips",
    signatories: [signatories[2], signatories[3]],
    type: SignatoryFormType.CLEVER,
  },
];

export const campaigns: Campaign[] = [
  {
    id: "c1",
    name: "3rd Grade Field Trip",
    description: "Q3 Field Trip to Zoo",
    package: packages[0],
    signatoryGroup: signatoryGroups[0],
    organization: organizations[0],
    status: "Active",
    schedule: false,
    startDate: new Date(),
    endDate: new Date(),
    modifyingUser: users[0],
    emailSubject: "Campaign 01 Subject",
    emailMessage: "This is Campaign 01",
  },
  {
    id: "c2",
    name: "4th Grade Field Trip",
    description: "Q1 Field Trip to Factory",
    package: packages[1],
    signatoryGroup: signatoryGroups[1],
    organization: organizations[0],
    status: "Active",
    schedule: false,
    startDate: new Date(),
    endDate: new Date(),
    modifyingUser: users[0],
    emailSubject: "Campaign 02 Subject",
    emailMessage: "This is Campaign 02",
  },
  {
    id: "c3",
    name: "5th Grade Field Trip",
    description: "Q4 Field Trip to Kidzania",
    package: packages[2],
    signatoryGroup: signatoryGroups[2],
    organization: organizations[0],
    status: "Active",
    schedule: false,
    startDate: new Date(),
    endDate: new Date(),
    modifyingUser: users[0],
    emailSubject: "Campaign 03 Subject",
    emailMessage: "This is Campaign 03",
  },
  {
    id: "c4",
    name: "Donation Request",
    description: "PTA Donation Signup Form",
    package: packages[1],
    signatoryGroup: signatoryGroups[1],
    organization: organizations[0],
    status: "Started",
    schedule: false,
    startDate: new Date(),
    endDate: new Date(),
    modifyingUser: users[0],
    emailSubject: "Campaign 04 Subject",
    emailMessage: "This is Campaign 04",
  },
];

export const permissions: Permission[] = [];
export const permissionTypes: PermissionType[] = [];

const enrollments: Enrollment[] = [
  {
    id: "e1",
    organization: organizations[1],
    grade: "1",
    schoolYearStart:
      new Date().getMonth() >= 6
        ? new Date().getFullYear() + 1
        : new Date().getFullYear(),
    schoolYearEnd:
      new Date().getMonth() >= 6
        ? new Date().getFullYear() + 2
        : new Date().getFullYear() + 1,
  },
  {
    id: "e2",
    organization: organizations[1],
    grade: "2",
    schoolYearStart:
      new Date().getMonth() >= 6
        ? new Date().getFullYear() + 1
        : new Date().getFullYear(),
    schoolYearEnd:
      new Date().getMonth() >= 6
        ? new Date().getFullYear() + 2
        : new Date().getFullYear() + 1,
  },
  {
    id: "e3",
    organization: organizations[1],
    grade: "3",
    schoolYearStart:
      new Date().getMonth() >= 6
        ? new Date().getFullYear() + 1
        : new Date().getFullYear(),
    schoolYearEnd:
      new Date().getMonth() >= 6
        ? new Date().getFullYear() + 2
        : new Date().getFullYear() + 1,
  },
  {
    id: "e4",
    organization: organizations[1],
    grade: "4",
    schoolYearStart:
      new Date().getMonth() >= 6
        ? new Date().getFullYear() + 1
        : new Date().getFullYear(),
    schoolYearEnd:
      new Date().getMonth() >= 6
        ? new Date().getFullYear() + 2
        : new Date().getFullYear() + 1,
  },
  {
    id: "e5",
    organization: organizations[1],
    grade: "5",
    schoolYearStart:
      new Date().getMonth() >= 6
        ? new Date().getFullYear() + 1
        : new Date().getFullYear(),
    schoolYearEnd:
      new Date().getMonth() >= 6
        ? new Date().getFullYear() + 2
        : new Date().getFullYear() + 1,
  },
  {
    id: "e6",
    organization: organizations[1],
    grade: "6",
    schoolYearStart:
      new Date().getMonth() >= 6
        ? new Date().getFullYear() + 1
        : new Date().getFullYear(),
    schoolYearEnd:
      new Date().getMonth() >= 6
        ? new Date().getFullYear() + 2
        : new Date().getFullYear() + 1,
  },
  {
    id: "e7",
    organization: organizations[1],
    grade: "7",
    schoolYearStart:
      new Date().getMonth() >= 6
        ? new Date().getFullYear() + 1
        : new Date().getFullYear(),
    schoolYearEnd:
      new Date().getMonth() >= 6
        ? new Date().getFullYear() + 2
        : new Date().getFullYear() + 1,
  },
];

export const students: Student[] = [
  {
    id: "s1",
    organization: organizations[1],
    firstname: "Timmy",
    lastname: "Pyun",
    email: "timmy@gmail.com",
    dateOfBirth: new Date(2000, 1, 1),
    enrollments: [enrollments[3]],
    signatories: [signatories[0]],
  },
  {
    id: "s2",
    organization: organizations[1],
    firstname: "Tommy",
    lastname: "Pyun",
    email: "tommy@gmail.com",
    dateOfBirth: new Date(2001, 1, 1),
    enrollments: [enrollments[2]],
    signatories: [signatories[0]],
  },
  {
    id: "s3",
    organization: organizations[1],
    firstname: "Tammy",
    lastname: "Pyun",
    email: "tammy@gmail.com",
    dateOfBirth: new Date(2002, 1, 1),
    enrollments: [enrollments[1]],
    signatories: [signatories[2], signatories[1]],
  },
];

export const documents: Document[] = [
  {
    id: "doc01",
    documentTemplate: documentTemplates[0],
    signatory: signatories[0],
    campaign: campaigns[0],
    status: DocumentStatus.PENDING,
  },
  {
    id: "doc02",
    documentTemplate: documentTemplates[0],
    signatory: signatories[0],
    campaign: campaigns[0],
    status: DocumentStatus.SIGNED,
  },
  {
    id: "doc03",
    documentTemplate: documentTemplates[0],
    signatory: signatories[0],
    campaign: campaigns[0],
    status: DocumentStatus.SIGNED,
  },
  {
    id: "doc04",
    documentTemplate: documentTemplates[0],
    signatory: signatories[0],
    campaign: campaigns[0],
    status: DocumentStatus.PENDING,
  },
  {
    id: "doc05",
    documentTemplate: documentTemplates[0],
    signatory: signatories[0],
    campaign: campaigns[0],
    status: DocumentStatus.REJECTED,
  },
];

export const myDocuments: Document[] = [
  {
    id: "doc01",
    documentTemplate: documentTemplates[0],
    signatory: signatories[0],
    campaign: campaigns[0],
    file: pdf,
    status: DocumentStatus.PENDING,
  },
];

const get_demo_date = () => {
  const datenow = new Date();
  return datenow.toISOString()
} 

export const chatDemo: History[] = [
  {
    id: 1,
    from: "John Smith",
    to: "User1",
    text: "Hi Good Morning!",
    timestamp : get_demo_date()
  },
  {
    id: 2,
    from: "User1",
    to: "John Smith",
    text: "Good morning. How are you?",
    timestamp: get_demo_date()
  },
];  

export const postCommentDemo: PostComment[] = [
  {
    id: "1",
    senderId: "431b6cf0-5839-45c6-aa02-5f5f6abfd422",
    senderFirstName: "Han",
    senderLastName: "Pyun",
    message: "This is a test message from Han",
    timestamp: "2024-10-10T03:02:57.957145555Z",
    likes: 0,
    replies: [],
    senderRole: "requestor",
    status: "active",
    campaignId: "",
  },
  {
    id: "2",
    senderId: "2",
    senderFirstName: "John",
    senderLastName: "Doe",
    message: "This is another message from John Doe",
    timestamp: "2024-10-10T03:02:57.957145555Z",
    likes: 0,
    replies: [],
    senderRole: "requestor",
    status: "active",
    campaignId: "",
  },
  {
    id: "3",
    senderId: "431b6cf0-5839-45c6-aa02-5f5f6abfd422",
    senderFirstName: "Han",
    senderLastName: "Pyun",
    message: "This my second message",
    timestamp: "2024-11-10T03:02:57.957145555Z",
    likes: 0,
    replies: [],
    senderRole: "requestor",
    status: "active",
    campaignId: "",
  },
];
